import {
    AccordionItemHeading,
    AccordionItemButton,
    Accordion,
    AccordionItemPanel,
} from 'react-accessible-accordion';
import colors from "shared/styles/colors";
import { IVariantProps, ThemeType } from "shared/styles/theme";
import styled, { css } from "styled-components";
import theme from "styled-theming";

export enum AccordionVariant {
    default = "default",
    grey = "grey",
    purple = "purple",
    transparent = "transparent"
}

const accordionItemPanelBackgroundColor = theme.variants("mode", "variant", {
    [AccordionVariant.default]: {
        [ThemeType.light]: colors.white,
        [ThemeType.dark]: colors.black
    },
    [AccordionVariant.grey]: {
        [ThemeType.light]: colors.uiGrey,
        [ThemeType.dark]: colors.black
    },
    [AccordionVariant.purple]: {
        [ThemeType.light]: colors.purpleBackground,
        [ThemeType.dark]: colors.dark4
    },
    [AccordionVariant.transparent]: {
        [ThemeType.light]: "transparent",
        [ThemeType.dark]: "transparent"
    }
});

const accordionItemPanelTextColor = theme.variants("mode", "variant", {
    [AccordionVariant.default]: {
        [ThemeType.light]: colors.black,
        [ThemeType.dark]: colors.white
    },
    [AccordionVariant.grey]: {
        [ThemeType.light]: colors.uiGrey,
        [ThemeType.dark]: colors.white
    },
    [AccordionVariant.purple]: {
        [ThemeType.light]: colors.black,
        [ThemeType.dark]: colors.white
    },
    [AccordionVariant.transparent]: {
        [ThemeType.light]: "transparent",
        [ThemeType.dark]: "transparent"
    }
});

const accordionItemHeaderTextColor = theme("mode", {
    [ThemeType.light]: colors.black,
    [ThemeType.dark]: colors.white
});

const accordionColors = theme("mode", {
    [ThemeType.light]: colors.black,
    [ThemeType.dark]: colors.white
})

export const AccordionStyled = styled(Accordion) <IAccordionStyledProps>`
    border: 1px solid ${colors.grey_1};
    ${(props) => props.$borderRadius ? css`
        border-radius: ${props.$borderRadius};
    ` : css`
        border-radius: 25px;
    `}
`

export const AccordionItemHeadingStyled = styled(AccordionItemHeading)`
    display: flex;
`

export const AccordionItemPanelStyled = styled(AccordionItemPanel)<IVariantProps<AccordionVariant>>`
    padding: 20px;
    animation: fadein 0.35s ease-in;
    background-color: ${accordionItemPanelBackgroundColor};
    color: ${accordionItemPanelTextColor};
    border-radius: 0px 0px 25px 25px;
`

export const AccordionChevronCss = css`
    cursor: pointer;
    &:after {
        float: right;
        content: '';
        height: 10px;
        width: 10px;
        margin-right: 10px;
        margin-top: 0px;
        border-bottom: 2px solid ${accordionColors};
        border-right: 2px solid ${accordionColors};
        transform: rotate(45deg);
    }

    &[aria-expanded='true']::after,
    &[aria-selected='true']::after {
        transform: rotate(225deg);
        margin-top: 4px;
    }
`;

export const AccordionItemButtonStyled = styled(AccordionItemButton) <AccordionItemButtonStyledProps>`
    border-top: ${props => props.$index !== 0 ? `1px solid ${colors.grey_1}` : "none"};
    color: ${accordionItemHeaderTextColor};
    font-size: var(--header-4-font-size);
    padding: 18px;
    width: 100%;
    text-align: left;
    ${AccordionChevronCss};
    &:after {
        margin-top: ${props => props.$containsFlexContainer ? "-12px" : "4px"};
    }
`

interface IAccordionStyledProps {
    $borderRadius?: string;
}

interface AccordionItemButtonStyledProps {
    $index: number;
    $containsFlexContainer?: boolean;
}

AccordionItemPanelStyled.defaultProps = {
    variant: AccordionVariant.default
}
